module.exports = __webpack_public_path__ + "static/media/CUB21.8362c59b.png";